import _defineProperty from "@babel/runtime/helpers/defineProperty";
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
import { NotFoundError } from '@cian/peperrors/shared';
import { GlobalEventsLogs } from '../internal/GlobalEventsLogs';
var globalEventsLogsSettings = {
  ttl: 60000
};
export function setupGlobalEventsLogs() {
  var settings = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
  globalEventsLogsSettings = _objectSpread(_objectSpread({}, globalEventsLogsSettings), settings);
}
export function initGlobalEventsLogs() {
  if (window.__cianGlobalEventsLogs) {
    return window.__cianGlobalEventsLogs;
  }
  window.__cianGlobalEventsLogs = new GlobalEventsLogs(globalEventsLogsSettings.ttl);
  return window.__cianGlobalEventsLogs;
}
export function getGlobalEventsLogs() {
  if (!window.__cianGlobalEventsLogs) {
    throw new NotFoundError({
      message: 'GlobalEventsLogs must be initialized before accessing it. Forgot to call init() before accessing log?',
      domain: '@cian/events-log/interface'
    });
  }
  return window.__cianGlobalEventsLogs;
}